import { forwardRef } from 'react';

import type { SVGIconProps } from '../types';

export const PortVgaIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_311"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_311)">
        <path
          d="M13.9965 11.0901H2.00355C1.45023 11.0901 1 10.6389 1 10.0845V5.73445C1 5.18002 1.45023 4.72888 2.00355 4.72888H13.9965C14.5498 4.72888 15 5.18002 15 5.73445V10.0845C15 10.6389 14.5498 11.0901 13.9965 11.0901ZM2.00355 5.04771C1.62555 5.04771 1.31818 5.35569 1.31818 5.73445V10.0845C1.31818 10.4633 1.62555 10.7712 2.00355 10.7712H13.9965C14.3745 10.7712 14.6818 10.4633 14.6818 10.0845V5.73445C14.6818 5.35569 14.3745 5.04771 13.9965 5.04771H2.00355Z"
          fill={color}
        />
        <path
          d="M13.4501 8.70654C13.0114 8.70654 12.6547 8.34914 12.6547 7.90948C12.6547 7.46982 13.0114 7.11241 13.4501 7.11241C13.8889 7.11241 14.2456 7.46982 14.2456 7.90948C14.2456 8.34914 13.8889 8.70654 13.4501 8.70654ZM13.4501 7.43124C13.187 7.43124 12.9729 7.64581 12.9729 7.90948C12.9729 8.17314 13.187 8.38771 13.4501 8.38771C13.7133 8.38771 13.9274 8.17314 13.9274 7.90948C13.9274 7.64581 13.7136 7.43124 13.4501 7.43124Z"
          fill={color}
        />
        <path
          d="M2.54986 8.70654C2.11141 8.70654 1.75441 8.34914 1.75441 7.90948C1.75441 7.46982 2.11141 7.11242 2.54986 7.11242C2.98832 7.11242 3.34532 7.46982 3.34532 7.90948C3.34532 8.34914 2.98832 8.70654 2.54986 8.70654ZM2.54986 7.43124C2.28673 7.43124 2.07259 7.64581 2.07259 7.90948C2.07259 8.17314 2.28673 8.38771 2.54986 8.38771C2.813 8.38771 3.02714 8.17314 3.02714 7.90948C3.02714 7.64581 2.813 7.43124 2.54986 7.43124Z"
          fill={color}
        />
        <path
          d="M10.5547 10.198H5.44532C5.00273 10.198 4.60659 9.90054 4.48218 9.47491L3.73254 6.90901C3.64282 6.6023 3.70136 6.27933 3.89259 6.02363C4.08382 5.76793 4.37654 5.62095 4.69568 5.62095H11.3037C11.6228 5.62095 11.9155 5.76761 12.1068 6.02363C12.298 6.27933 12.3565 6.6023 12.2668 6.90901L11.5172 9.47491C11.3934 9.90054 10.9973 10.198 10.5547 10.198ZM4.696 5.93978C4.47804 5.93978 4.27823 6.03989 4.14745 6.21461C4.01668 6.38932 3.97691 6.60963 4.03832 6.81942L4.78764 9.38532C4.87259 9.67608 5.14305 9.87918 5.44532 9.87918H10.5544C10.8566 9.87918 11.1271 9.67608 11.212 9.38532L11.9617 6.81942C12.0228 6.60995 11.983 6.38932 11.8525 6.21461C11.7218 6.03989 11.522 5.93978 11.304 5.93978H4.696Z"
          fill={color}
        />
        <path
          d="M5.21559 7.74114C4.91746 7.74114 4.67468 7.49787 4.67468 7.19914C4.67468 6.9004 4.91746 6.65713 5.21559 6.65713C5.51373 6.65713 5.7565 6.9004 5.7565 7.19914C5.7565 7.49787 5.51405 7.74114 5.21559 7.74114ZM5.21559 6.97596C5.09278 6.97596 4.99287 7.07607 4.99287 7.19914C4.99287 7.3222 5.09278 7.42231 5.21559 7.42231C5.33841 7.42231 5.43832 7.3222 5.43832 7.19914C5.43832 7.07607 5.33841 6.97596 5.21559 6.97596Z"
          fill={color}
        />
        <path
          d="M7.09287 7.74114C6.79473 7.74114 6.55196 7.49787 6.55196 7.19914C6.55196 6.9004 6.79473 6.65713 7.09287 6.65713C7.391 6.65713 7.63377 6.9004 7.63377 7.19914C7.63377 7.49787 7.391 7.74114 7.09287 7.74114ZM7.09287 6.97596C6.97005 6.97596 6.87014 7.07607 6.87014 7.19914C6.87014 7.3222 6.97005 7.42231 7.09287 7.42231C7.21568 7.42231 7.31559 7.3222 7.31559 7.19914C7.31559 7.07607 7.21568 6.97596 7.09287 6.97596Z"
          fill={color}
        />
        <path
          d="M8.97014 7.74114C8.672 7.74114 8.42923 7.49787 8.42923 7.19914C8.42923 6.9004 8.672 6.65713 8.97014 6.65713C9.26827 6.65713 9.51105 6.9004 9.51105 7.19914C9.51105 7.49787 9.26859 7.74114 8.97014 7.74114ZM8.97014 6.97596C8.84732 6.97596 8.74741 7.07607 8.74741 7.19914C8.74741 7.3222 8.84732 7.42231 8.97014 7.42231C9.09296 7.42231 9.19286 7.3222 9.19286 7.19914C9.19286 7.07607 9.09296 6.97596 8.97014 6.97596Z"
          fill={color}
        />
        <path
          d="M10.8474 7.74114C10.5493 7.74114 10.3065 7.49787 10.3065 7.19914C10.3065 6.9004 10.5493 6.65713 10.8474 6.65713C11.1455 6.65713 11.3883 6.9004 11.3883 7.19914C11.3883 7.49787 11.1455 7.74114 10.8474 7.74114ZM10.8474 6.97596C10.7246 6.97596 10.6247 7.07607 10.6247 7.19914C10.6247 7.3222 10.7246 7.42231 10.8474 7.42231C10.9702 7.42231 11.0701 7.3222 11.0701 7.19914C11.0701 7.07607 10.9702 6.97596 10.8474 6.97596Z"
          fill={color}
        />
        <path
          d="M6.15455 9.16182C5.85641 9.16182 5.61364 8.91856 5.61364 8.61982C5.61364 8.32108 5.85641 8.07782 6.15455 8.07782C6.45268 8.07782 6.69546 8.32108 6.69546 8.61982C6.69546 8.91856 6.453 9.16182 6.15455 9.16182ZM6.15455 8.39664C6.03173 8.39664 5.93182 8.49675 5.93182 8.61982C5.93182 8.74289 6.03173 8.843 6.15455 8.843C6.27737 8.843 6.37727 8.74289 6.37727 8.61982C6.37727 8.49675 6.27737 8.39664 6.15455 8.39664Z"
          fill={color}
        />
        <path
          d="M8.03472 9.16182C7.73658 9.16182 7.49381 8.91856 7.49381 8.61982C7.49381 8.32108 7.73658 8.07782 8.03472 8.07782C8.33285 8.07782 8.57563 8.32108 8.57563 8.61982C8.57563 8.91856 8.33285 9.16182 8.03472 9.16182ZM8.03472 8.39664C7.9119 8.39664 7.81199 8.49675 7.81199 8.61982C7.81199 8.74288 7.9119 8.843 8.03472 8.843C8.15753 8.843 8.25744 8.74288 8.25744 8.61982C8.25744 8.49675 8.15753 8.39664 8.03472 8.39664Z"
          fill={color}
        />
        <path
          d="M9.84257 9.16182C9.54443 9.16182 9.30166 8.91856 9.30166 8.61982C9.30166 8.32108 9.54443 8.07782 9.84257 8.07782C10.1407 8.07782 10.3835 8.32108 10.3835 8.61982C10.3835 8.91856 10.141 9.16182 9.84257 9.16182ZM9.84257 8.39664C9.71975 8.39664 9.61984 8.49675 9.61984 8.61982C9.61984 8.74288 9.71975 8.843 9.84257 8.843C9.96539 8.843 10.0653 8.74288 10.0653 8.61982C10.0653 8.49675 9.96539 8.39664 9.84257 8.39664Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

PortVgaIcon.displayName = 'PortVgaIcon';
